<template>
    <div v-if="exibeAnuncio && adsBanner" class="ad-container" style="position:fixed; z-index:99; height: 150px; bottom: 0px;left: 0px;right: 0px;margin-bottom: 0px;">
        <v-card>
            <v-layout flex wrap>
                <v-flex style="position: absolute; right: 0; z-index:9999">
                    <v-btn
                        v-if="mostraFecharDialog"
                        color="error"
                        @click="adsBanner = false"><v-icon>mdi-close</v-icon></v-btn>
                    <v-btn
                        v-else
                        color="error">
                        <v-progress-circular
                            :size="30"
                            color="white"
                            indeterminate
                            />
                    </v-btn>
                </v-flex>
                
                
                <Adsense
                    xs6
                    data-ad-client="ca-pub-5511611659398318"
                    data-ad-slot="2598340340"
                    data-ad-format="auto"
                    data-ad-test
                    :data-full-width-responsive="'true'"
                >
                </Adsense>
                <!--<Banner xs6/>-->
            </v-layout>
        </v-card>
    </div>
</template>
<script>
import { ANUNCIO } from '../../utils/types'
import Banner from './Banner.vue'
import {
  mapState
} from 'vuex'
export default {
    components: { Banner },
    data: () => ({
        exibeAnuncio: false,
        adsDialog: true,
        adsBanner: true,
        mostraFecharDialog: false,
        anuncio: {
            id: null,
            titulo: 'Assine o plano pecuarista',
            youtube_src: 'CHJtDyWAuMg',
            img_src: null,
            link: 'https://www.campoonline.com.br/produtos/aplicativo-do-pecuarista-1-ano-de-licenca/',
            idioma: 0,
            tempo_pular: 30
        }
    }),
    watch: {
        'user'() {
            this.adsDialog = true
            this.exibeAnuncio = this.getAcessoModulo({ user: this.user, modulo: ANUNCIO })
            console.log('e', this.exibeAnuncio)
            if (this.exibeAnuncio) {
                setTimeout(() => {
                    this.mostraFecharDialog = true
                }, this.anuncio.tempo_pular * 1000)
            }
        }
    },
    computed: {
        ...mapState('app', ['step', 'user', 'trava_back', 'curr_version', 'strings', 'idioma'])
    },
    async mounted () {
        this.adsDialog = true
        this.exibeAnuncio = this.getAcessoModulo({ user: this.user, modulo: ANUNCIO })
        if (this.exibeAnuncio) {
            setTimeout(() => {
                this.mostraFecharDialog = true
            }, this.anuncio.tempo_pular * 1000)
        }
    },
    methods: {
        async anuncioClique (anuncio) {
            try {
                let au = await this.axios.post('anuncios/registerClique', { id: anuncio.id })
                let anuncioUser = au.data.data
                if (!anuncioUser) throw new Exception('Erro de clique')
                let win = window.open(anuncio.link, '_blank')
                if (!win) window.location.href = anuncio.link

            } catch(e) {
                window.location.href = anuncio.link
            }
        
        }
    }
}
</script>
